import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(email, password);
      toast.success("Bienvenue !");
      nav(data.role === "admin" ? "/admin" : "/catalog");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F3ED] flex">
      <div className="hidden lg:flex lg:w-1/2 relative">
        <img
          src="https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=srgb&fm=jpg"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
        <div className="relative z-10 p-12 self-end text-white">
          <div className="text-xs tracking-[0.25em] uppercase font-semibold mb-4 text-[#F5F3ED]">matchappart</div>
          <h2 className="font-serif text-4xl leading-tight italic">« Chez soi, ailleurs. »</h2>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <Link to="/" className="font-serif text-2xl text-[#2B3029]" data-testid="login-brand">matchappart</Link>
          <h1 className="font-serif text-4xl mt-10 text-[#1A1A1A]">Connexion</h1>
          <p className="mt-3 text-sm text-[#666]">
            L'accès est réservé aux membres pré-approuvés par l'administrateur.
          </p>
          <form onSubmit={submit} className="mt-10 space-y-5">
            <div>
              <label className="text-xs tracking-[0.2em] uppercase font-semibold text-[#666]">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full mt-2 px-4 py-3 bg-white border border-[#E5E1D8] rounded-md focus:border-[#8C6C50] focus:outline-none focus:ring-2 focus:ring-[#8C6C50]/20"
                placeholder="vous@exemple.fr"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <label className="text-xs tracking-[0.2em] uppercase font-semibold text-[#666]">Mot de passe</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full mt-2 px-4 py-3 bg-white border border-[#E5E1D8] rounded-md focus:border-[#8C6C50] focus:outline-none focus:ring-2 focus:ring-[#8C6C50]/20"
                data-testid="login-password-input"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full py-3.5 rounded-full text-sm font-medium disabled:opacity-60"
              data-testid="login-submit-btn"
            >
              {loading ? "Connexion…" : "Se connecter"}
            </button>
          </form>
          <p className="mt-6 text-sm text-[#666]">
            Vous avez reçu une invitation ?{" "}
            <Link to="/register" className="text-[#8C6C50] underline underline-offset-4" data-testid="login-to-register">
              Créer mon compte
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
